/**
 * @file Feux d'artifice du hub (cosmetiques) : achat en gemmes / Rubis, equipement, style actif.
 */
import { fail, okVoid } from '@shared/types';
import type { Result } from '@shared/types';
import type { FireworkStyle } from '@config/types';
import type { SimContext } from '../Context';

export class FireworkService {
  constructor(private readonly ctx: SimContext) {}

  owns(id: string): boolean {
    return this.ctx.data.fireworks.owned.includes(id);
  }

  /** Style du feu d'artifice equipe. */
  activeStyle(): FireworkStyle {
    return this.ctx.index.firework(this.ctx.data.fireworks.equipped).style;
  }

  buy(id: string): Result {
    const ctx = this.ctx;
    const fw = ctx.config.fireworks.find((f) => f.id === id);
    if (!fw) return fail('unknownId');
    if (this.owns(id)) return fail('alreadyOwned');
    return ctx.tx.purchase(fw.cost, `firework:${id}`, () => {
      ctx.data.fireworks.owned.push(id);
      ctx.bus.emit('FireworkBought', { id });
      return okVoid;
    });
  }

  equip(id: string): Result {
    const ctx = this.ctx;
    if (!ctx.config.fireworks.some((f) => f.id === id)) return fail('unknownId');
    if (!this.owns(id)) return fail('notOwned');
    ctx.data.fireworks.equipped = id;
    ctx.bus.emit('FireworkEquipped', { id });
    return okVoid;
  }
}
